import React from "react";
import { Text } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";

import styles from "../TripView.module.css";

const TripOverview = ({ trip, heroImage }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.overviewSection}>
      <div className={styles.heroWrap}>
        {heroImage ? (
          <>
            <img src={heroImage} alt={trip?.title || "trip"} className={styles.heroImage} />
            <div className={styles.heroOverlay} />
          </>
        ) : (
          <div className={styles.heroFallback}>
            <Text size="sm" color="muted">
              {t("tripPublication.tripView.empty.noImage")}
            </Text>
          </div>
        )}
      </div>

      <article className={styles.summaryCard}>
        <Text as="h3" size="xxl" weight="bold" className={styles.tripTitle}>
          {trip?.title || "-"}
        </Text>

        <div className={[styles.summaryBlock, styles.summaryBlockPrimary].join(" ")}>
          <Text as="p" size="xs" weight="bold" className={styles.blockLabel}>
            {t("tripPublication.tripView.labels.summary")}
          </Text>
          <Text as="p" size="sm">
            {trip?.smallDescription || t("tripPublication.tripView.empty.noSummary")}
          </Text>
        </div>

        <div className={styles.summaryBlock}>
          <Text as="p" size="xs" weight="bold" className={[styles.blockLabel, styles.detailsBlockLabel].join(" ")}>
            {t("tripPublication.tripView.labels.details")}
          </Text>
          <Text as="p" size="sm" color="muted">
            {trip?.detailedDescription || t("tripPublication.tripView.empty.noDetails")}
          </Text>
        </div>
      </article>
    </section>
  );
};

export default TripOverview;
